export default "__VITE_ASSET__C0yx8I2z__"